import { createContext, useContext, useEffect, useMemo } from 'react';
import { useLoadAssociationsFromObjectType } from '../associations/hooks/useLoadAssociationsFromObjectType';
import { CardComponent as CardComponentV1 } from './CardComponent';
import { CardComponentV2 } from './CardComponentV2';
import { useAddRenderComponents } from '../render/renderComponents/useAddRenderComponent';
import { useHasCardV2 } from 'crm-object-board-core/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_MAP = new Map();
const StoreContext = /*#__PURE__*/createContext({
  associationsPerType: EMPTY_MAP
});
export function CardProvider({
  children
}) {
  const {
    data: associationsPerType,
    loading
  } = useLoadAssociationsFromObjectType();
  const addRenderComponents = useAddRenderComponents();
  const hasCardV2 = useHasCardV2();
  useEffect(() => {
    addRenderComponents([{
      key: 'renderCard',
      renderComponent: CardComponentV1
    }, {
      key: 'renderStyledCard',
      renderComponent: hasCardV2 ? CardComponentV2 : undefined
    }]);
  });
  const value = useMemo(() => {
    if (loading || !associationsPerType) {
      return {
        associationsPerType: EMPTY_MAP
      };
    }
    return {
      associationsPerType
    };
  }, [loading, associationsPerType]);
  return /*#__PURE__*/_jsx(StoreContext.Provider, {
    value: value,
    children: children
  });
}
export const useCardStore = () => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useCardStore must be inside CardProvider');
  }
  return store;
};